module.exports = __webpack_public_path__ + "img/03.d9aba880.jpg";